import { useEffect, useState } from "react";
import useFirestore from "shared/hooks/useFirestore";
import useGetBranchId from "shared/hooks/useGetBranchId";

const useStudentActivityPreview = (student_uid:string) => {
    interface Activity{
        title:string,
        contents:string,
        video:string
    }
    const { readFirestoreOneDoc } = useFirestore();
    const { getBranchId } = useGetBranchId();
    const [activityList, setActivityList] = useState<Activity[]>([]);
    const date = new Date();

    useEffect(() => {
        getStudentActivityList();
    }, [])

    const getStudentActivityList = async() => {
        const branch_id = await getBranchId();
        const activity_list:Activity[] = [];
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        const maxDate = new Date(year, month, 0).getDate();
        for(let i = 1; i <= maxDate; i++){
            const activity = await readFirestoreOneDoc(`Activity/${branch_id}/${year}/${month}/${i}`, student_uid).then(res => {
                if(res.exists()){
                    return res.data();
                }
            })
            if(activity){
                activity_list.push({title:activity.title, contents:activity.contents, video:activity.video});
            }
            
        }
        setActivityList(activity_list);
    }

    return {activityList}
}

export default useStudentActivityPreview;